export default {
  // Modos
  "common.mode.auto": "Modo automático (uso de energía autogenerada)",
  "common.mode.economy": "Modo económico",
  "common.mode.exigency": "Modo de emergencia",

  // Dispositivos
  "common.grid": "Red eléctrica",
  "common.evChargers": "Cargadores(varios)",
  "common.evCharger": "Cargador",
  "common.pv": "Fotovoltaico (PV)",
  "common.inverter": "Inversor (dispositivo de conversión de voltaje)",
  "common.pcs": "Inversor + batería",
  "common.terminal": "Dispositivo terminal",
  "common.airc": "Aire acondicionado (AC)",
  "common.engine": "Motor",
  "common.battery": "Batería",
  "common.metter": "Medidor de electricidad",
  "common.other": "Otros",
  "common.power": "Potencia",
  "common.powerTotal": "Potencia total",
  "common.voltage": "Voltaje",
  "common.electricity": "Electricidad",
  "common.current": "Corriente",
  "common.homeUsage": "Carga total doméstica",
  "common.battery.power": "Potencia de la batería",

  // Datos
  "common.noDataAvailable": "No hay datos disponibles en este momento~",
  "common.tips": "Consejos",
  "common.reset": "Restablecer (borrar)",
  "common.currencyUnit": "¥ (yuan)",
  "common.submiting": "Enviando... espere un momento...",
  "common.close": "Cerrar",
  "common.from": "De",
  "common.useIn": "Para",
  "common.energyPercent": "Porcentaje de uso de energía",
  "common.dataFlow": "Flujo de datos",
  "common.getDataIng": "Obteniendo datos... espere un momento...",
  "common.pageLoading": "Cargando página... espere un momento...",
  "common.reseting": "Restableciendo página... espere un momento...",
  "common.save": "Guardar",
  "common.onlyNumberTips": "Solo se pueden ingresar números",
  "common.offline": "Sin conexión (no conectado a internet)",
  "common.online": "Con conexión (conectado a internet)",
  "common.fault": "Error (problema)",
  "common.charge": "Cargar (batería)",
  "common.discharge": "Descargar (uso de energía de la batería)",
  "common.buy": "Comprar",
  "common.sell": "Vender",
  "common.loadingInfo": "Cargando... espere un momento...",

  // Funcionalidades comunes
  "common.moreFeatures": "Más funcionalidades",
  "common.confirm": "Confirmar",
  "common.saveing": "Guardando... espere un momento...",
  "common.searchPlacholder": "Ingrese una palabra clave para buscar",
  "common.iSee": "Entiendo",
  "common.pageErrorTips1": "Oh, ocurrió un error en la página~",
  "common.pageErrorTips2": "Actualice la página o contacte al equipo de soporte~",
  "common.refresh": "Actualizar",
  "common.backToHome": "Volver a la página de inicio",
  "common.checkTips": "Verificando... espere un momento...",
  "common.back": "Volver",
  "common.cancel": "Cancelar (borrar)",
  "common.optional": "Opcional (no obligatorio)",
  "common.required": "Obligatorio para ingresar",
  "common.status": "Estado",
  "common.statusNoDelete": "No eliminado",
  "common.statusDelete": "Eliminado",
  "common.submit": "Enviar",
  "common.disable": "Desactivar",
  "common.enable": "Activar",
  "common.year": "Año",
  "common.month": "Mes",
  "common.day": "Día",
  "common.version": "Versión:",
  "common.backHome": "Volver a la página de inicio",
  "common.backHomeSorry": "Lo sentimos, esta página no es válida",
  "common.requestTips1": "La obtención de datos está en curso, no vuelva a enviar",
  "common.requestTips2": "Notificaciones del sistema",
  "common.requestTips3": "La sesión de inicio de sesión ha expirado, inicie sesión nuevamente",
  "common.requestTips4": "Iniciar sesión nuevamente",
  "common.requestTips5": "El inicio de sesión no es válido o la sesión ha expirado, inicie sesión nuevamente.",
  "common.requestTips6": "Error del servidor, por favor intente de nuevo más tarde.",
  "common.requestTips7": "La solicitud del sistema ha expirado",
  "common.requestTips8": "Interfaz del sistema",
  "common.requestTips9": "Error",
  "common.iknow": "Entiendo",
  "common.logoutSuccess": "Cierre de sesión exitoso",
  
  // Sección de más información
  "common.knowMore.title": "Para más información, contacte a Beineng",
  "common.knowMore.email": "Correo electrónico para contacto",
  "common.knowMore.phone": "Número de teléfono para contacto",
  "common.knowMore.wechat": "WeChat para contacto",
  "common.knowMore.website": "Dirección del sitio web oficial",
  "common.knowMore.address": "Dirección para contacto",
  "common.knowMore.addressDetail": "Provincia de Guangdong, Ciudad de Dongguan, Distrito de Huangjiang, Pueblo de Huangjingkeng, Calle Qingxi 8, Edificio 5, Habitación 1205, Habitación 1301",
  
  // Conexión local
  "common.localConnection": "Conexión local",
  "common.operateInApp": "Realice operaciones en la aplicación!",
  
  "common.enbleStaus": "Estado activado",
  "common.battery.status": "No cargando, no descargando",

  // Relacionado con la cuenta
  "account.forgetThePassword": "Olvidó la contraseña",
  "account.logInDirectly": "Inicio de sesión directo",
  "account.tips1": "Redirigiendo a la página... espere un momento...",
  "account.tips2": "Primero lea y acepte los términos de uso!",
  "account.autoLogin": "Inicio de sesión automático",
  "account.userLogin": "Inicio de sesión del usuario",
  "account.registerTips": "¿No tiene una cuenta? Haga clic aquí para registrarse",
  "account.userEmail": "Nombre de usuario / correo electrónico",
  "account.userEmailTips": "Ingrese el nombre de usuario o el correo electrónico",
  "account.password": "Contraseña",
  "account.passwordTips": "Ingrese la contraseña",
  "account.submit": "Enviar",
  "account.submitTips": "Enviando... espere un momento...",
  "account.otherLoginTips": "O seleccione otro método de inicio de sesión",
  "account.userRegistration": "Registro de usuario",
  "account.userName": "Nombre de usuario",
  "account.userNameTips": "Ingrese el nombre de usuario",
  "account.emailTips1": "Ingrese la dirección de correo electrónico",
  "account.emailTips2": "Formato de correo electrónico no válido",
  "account.phone": "Teléfono",
  "account.phoneTips1": "Ingrese el número de teléfono",
  "account.phoneTips2": "Número de teléfono no válido",
  "account.phoneTips3": "Ingrese el número de teléfono",
  "account.passwordTips1": "Ingrese la contraseña (6-30 caracteres)",
  "account.passwordTips2": "Formato de contraseña no válido: la contraseña debe contener letras inglesas, números, guión bajo (_), guión (-) y punto (.), con una longitud de 6-12 caracteres",
  "account.passwordTips3": "Las dos contraseñas ingresadas no coinciden, verifique y vuelva a ingresar!",
  "account.passwordTips4": "Ingrese la contraseña: la contraseña debe contener letras inglesas, números, guión bajo (_), guión (-) y punto (.)",
  "account.passwordTips5": "Confirmar contraseña",
  "account.passwordTips6": "Ingrese para confirmar la contraseña",
  "account.passwordTips7": "Las dos contraseñas ingresadas no coinciden, verifique y vuelva a ingresar!",
  "account.passwordTips8": "Ingrese para confirmar la contraseña",
  "account.passwordTips9": "¡Felicidades! El registro fue exitoso!",
  "account.passwordTips10": "Su nombre de usuario es:",
  "account.emailIs": "Su correo electrónico es:",
  "account.goToLoginPage": "Será redirigido a la página de inicio de sesión automáticamente en s segundos",
  "account.goLogin": "Iniciar sesión",
  "account.goRegister": "Registrarse",
  "account.loginSuccess": "Inicio de sesión exitoso",
  "account.email": "Correo electrónico",
  "account.sologn": "Proporcionamos una plataforma de energía integrada diseñada especialmente para usted",
  "account.pleaseAgree": "He leído y aceptado los términos de uso",
  "userAgreement.privacyPolicy": "Política de privacidad",

  // Relacionado con el código de verificación
  "account.code": "Código de verificación",
  "account.codeTips": "Ingrese el código de verificación",
  "account.codeTips2": "Código de verificación no válido",

    "account.inviteCodeTips": "Por favor, introduzca el código de invitación",
    "account.inviteCodeHint": "Por favor, contacte al instalador o al personal de operación y mantenimiento para obtener el código de invitación",
  // Relacionado con la modificación y recuperación de contraseña
  "account.modifyPasswordByAccount": "Modificar contraseña a través de la cuenta",
  "account.modifyPasswordByEmail": "Modificar contraseña a través del correo electrónico",
  "account.getPasswordByAccount": "Obtener contraseña a través de la cuenta",
  "account.getPasswordByEmail": "Obtener contraseña a través del correo electrónico",

  "account.sendEmailTips": "El código de verificación ha sido enviado al correo electrónico, verifíquelo",
  "account.name": "Nombre de la cuenta",
  "account.newPassword": "Nueva contraseña",
  "account.confirmNewPassword": "Confirmar nueva contraseña",
  "account.nameTips": "Ingrese el nombre de la cuenta",
  "account.passwordModifySuccess": "Modificación de contraseña exitosa",
  "account.emailCode": "Código de verificación por correo electrónico",
  "account.emailCodeTips": "Ingrese el código de verificación por correo electrónico",
  "account.emailCodeTips2": "Código de verificación por correo electrónico no válido",
  "account.emailModifySuccess": "Modificación de contraseña exitosa",
  "account.passworTips1": "¡Su contraseña ha sido recuperada!",
  "account.passwordTips11": "Ingrese para confirmar la contraseña",
  "account.passwordTips12": "Ingrese la nueva contraseña",
  "account.nickname": "Apodo",
  "account.modifyNickname": "Modificar apodo",
  "account.modifyNicknameSuccess": "¡Modificación de apodo exitosa!",
  "account.nicknameTips": "Ingrese el apodo",
  "account.nicknameError": "¡Modificación de apodo fallida!",

  // Registro y inicio de sesión rápidos
  "account.login": "Iniciar sesión",
  "account.quickRegister": "Registro rápido",
  "account.sendCode": "Obtener código",
  "account.sendTips": "Se puede reenviar después de s segundos",
  "account.sendEmailIng": "Enviando correo electrónico... espere un momento...",
  "account.emailNotEmpty": "El campo de correo electrónico no puede estar vacío",
  "account.registerAccount": "Registro de cuenta",
  "account.registerWelcome": "Bienvenido al registro de SusprSafe",
  "account.usernameLimit": "El nombre de usuario debe comenzar con una letra, solo puede contener letras, números y guión bajo (_), con una longitud de 5-15 caracteres",

  // Información de copyright
  "copyright.desc2": "Información de registro del sitio web: Número de registro ICP de la Provincia de Guangdong 2021169764",

  // Editar información del usuario
  "editUserInfo.editUserInformation": "Editar información del usuario",
  "editUserInfo.modifyUsername": "Modificar nombre de usuario",
  "editUserInfo.changePictures": "Cambiar foto de perfil",
  "editUserInfo.savePicturesSuccess": "Guardado de foto de perfil exitoso",
  "editUserInfo.saveError": "Guardado fallido",
  "editUserInfo.pictureLimit": "El tamaño de la foto no puede exceder 2 MB",
  "editUserInfo.uploadPicture": "Subir foto de perfil",
  "editUserInfo.picturePreview": "Vista previa",
  
  "editUserInfo.bindPhoneNumber": "Vincular número de teléfono",
  "editUserInfo.bindEmail": "Vincular correo electrónico",
  "editUserInfo.changePassword": "Modificar contraseña",

  "editUserInfo.notificationSettings": "Configuración de notificaciones",
  "editUserInfo.editAccount": "Editar información de la cuenta",
  "editUserInfo.waitBingting": "Vinculando... espere un momento...",
  "editUserInfo.collapse": "Colapsar (separar)",
  "editUserInfo.modifyBinding": "Modificar vinculación",
  
  "editUserInfo.emailAddress": "Dirección de correo electrónico",
  "editUserInfo.tips1": "Vinculación de correo electrónico exitosa",
  "editUserInfo.tips2": "Guardado fallido",
  "editUserInfo.tips3": "Enviando código de verificación por correo electrónico... espere un momento...",
  "editUserInfo.tips4": "El código de verificación ha sido enviado al correo electrónico xxxx, verifíquelo",
  "editUserInfo.tips5": "¡Envío de código de verificación fallido!",
  "editUserInfo.tips6": "Número de teléfono vinculado",
  "editUserInfo.tips7": "Correo electrónico vinculado",
  "editUserInfo.emailTips1": "Ingrese la dirección de correo electrónico",
  "editUserInfo.emailTips2": "Formato de correo electrónico no válido",
  "editUserInfo.emailTips3": "Se puede reenviar después de xxxx segundos",
  "editUserInfo.emailTips4": "Obtener código",
  "editUserInfo.emailTips5": "El campo de código de verificación por correo electrónico no puede estar vacío",
  "editUserInfo.emailTips6": "Código de verificación por correo electrónico no válido",
  "editUserInfo.emailCode": "Código de verificación por correo electrónico",
  "editUserInfo.save": "Guardar",

  // Relacionado con la vinculación de teléfono
  "editUserInfo.phoneTips1": "Vinculación de número de teléfono exitosa",
  "editUserInfo.phoneTips2": "Enviando código de verificación por SMS... espere un momento...",
  "editUserInfo.phoneTips3": "El código de verificación por SMS ha sido enviado al número xxxx, verifíquelo",
  "editUserInfo.phoneTips4": "¡Envío de código de verificación por SMS fallido!",
  "editUserInfo.phoneTips5": "Ingrese el número de teléfono",
  "editUserInfo.phoneTips6": "Formato de número de teléfono no válido",
  "editUserInfo.phoneTips7": "Obtener código por SMS",
  "editUserInfo.phoneTips8": "Código de verificación por SMS",
  "editUserInfo.phoneTips9": "El campo de código de verificación por SMS no puede estar vacío",
  "editUserInfo.phoneTips10": "Código de verificación por SMS no válido",
  "editUserInfo.phone": "Número de teléfono",


  // Configuración de notificaciones
  "editUserInfo.noticeTips1": "¡Obtención de configuración de notificaciones fallida!",
  "editUserInfo.noticeTips2": "¡Guardado de configuración de notificaciones exitoso!",
  "editUserInfo.noticeTips3": "Notificación de bajo nivel de batería",
  "editUserInfo.noticeTips4": "Notificación de finalización de carga",
  "editUserInfo.errorNotification": "Notificación de error",
  "editUserInfo.updateNotification": "Notificación de actualización",
  "editUserInfo.monthlyStatisticsNotification": "Notificación de estadísticas mensuales",
  "editUserInfo.notificationMethod": "Método de recepción",

  // Consejos relacionados con el nombre de usuario
  "editUserInfo.userNameTips1": "Guardado de nombre de usuario exitoso",
  "editUserInfo.userNameTips2": "Guardado de nombre de usuario fallido",
  "editUserInfo.userNameTips3": "Ingrese el nombre de usuario",
  "editUserInfo.userNameTips4": "Formato de nombre de usuario no válido: solo puede contener números, guión bajo (_) y letras inglesas",
  "editUserInfo.userNameTips5": "Ingrese el nombre de usuario",
  "editUserInfo.userNameTips6": "Guardando... espere un momento...",
  "editUserInfo.userName": "Nombre de usuario",

  // Consejos para editar la foto de perfil
  "editUserInfo.avatorTips": "Haga clic para cambiar la foto de perfil",
  "editUserInfo.verifyCodeTips1": "Ingrese el código de verificación recibido:",
  "editUserInfo.verifyCodeTips2": "Para la seguridad de su cuenta, haga clic en el botón inferior y envíe el código de verificación al número de teléfono original:",
  "editUserInfo.verifyCodeTips3": "Obtener código",
  "editUserInfo.verifyCodeTips4": "Verificación de número de teléfono original exitosa, ingrese el nuevo número de teléfono para vincular",
  "editUserInfo.verifyCodeTips5": "Para la seguridad de su cuenta, haga clic en el botón inferior y envíe el código de verificación al correo electrónico original:",
  "editUserInfo.verifyCodeTips6": "Verificación de correo electrónico original exitosa, ingrese el nuevo correo electrónico",
  "editUserInfo.verifyCodeTips7": "Contraseña antigua",
  "editUserInfo.verifyCodeTips8": "¡Primero vincule el correo electrónico!",
  "editUserInfo.verifyCodeTips9": "El código de verificación ha sido enviado al correo electrónico, verifíquelo",
  "editUserInfo.verifyCodeTips10": ", será redirigido a la página de inicio de sesión automáticamente",

  // Relacionado con las notificaciones
  "hems.notice.title": "Título de la notificación", 
  "hems.notice.content": "Contenido de la notificación", 
  "hems.notice.operate": "Operación",
  "hems.notice.noRead": "No leído",
  "hems.notice.read": "Leído",
  "hems.notice.warning": "Advertencia",
  "hems.notice.error": "Error",
  "hems.notice.success": "Cálculo de estadísticas",
  "hems.notice.sys": "Información del sistema",
  "hems.notice.operateSuccess": "Operación exitosa",
  "hems.notice.operateTips": "Seleccione un elemento para la operación",

  // Página de inicio
  "hems.home.selfuseRate": "Porcentaje de uso propio",
  "hems.home.percent": "Porcentaje",
  "hems.home.todayData": "Datos de hoy",
  "hems.home.todayPowerGeneration": "Generación de electricidad de hoy",
  "hems.home.salesIncome": "Ingreso por venta de electricidad",
  "hems.home.saved": "Ha ahorrado",
  "hems.home.reduce": "Reducción de emisiones de carbono",
  "hems.home.tips1": "No hay datos disponibles en este momento, aún no ha vinculado xxxx",
  "hems.home.criticalLoad": "Carga crítica",
  "hems.home.keyVoltage": "Voltaje crítico",
  "hems.home.householdLoad": "Carga doméstica",
  "hems.home.householdVoltage": "Voltaje doméstico",
  "hems.home.generalLoad": "Carga general",
  "hems.home.generalVoltage": "Voltaje general",
  "hems.home.batteryHealth": "Estado de salud de la batería",
  "hems.home.averageTemp": "Temperatura promedio",
  "hems.home.gridLoad": "Carga de la red eléctrica",
  "hems.home.toggeleDataSource": "Los datos mostrados han sido modificados como sigue:",
  "hems.home.toggleTips": "¿Desea modificar?",
  "hems.home.modeSending": "Enviando comando de modo... espere un momento...",
  "hems.home.modeSuccess": "¡Comando de modificación de modo enviado exitosamente!",
  "hems.home.isOnline": "¿Está conectado a internet?",
  "hems.home.useStatus": "Estado de uso",
  "hems.home.workModeText": "Modo de trabajo actual:",
  "hems.home.toggleDataSourceText": "Los datos mostrados han sido modificados como sigue:",
  "hems.ev.charge.status": "Estado de carga",
  "hems.ev.charge.time": "Tiempo de carga",
  "hems.ev.charge.count": "Número de cargas reales (a lo largo del tiempo)",
  "hems.ev.charge.status.empty": "Vacío",
  "hems.ev.charge.status.ing": "Conectado a la batería. Cargando",
  "hems.ev.charge.status.null": "Conectado a la batería, pero no cargando",
  "hems.ev.charge.status.error": "Error",
  "hems.hour": "Hora",
  "hems.minue": "Minuto",
  "hems.ev.chagre.number": "Número de cargador",

  // Guía del usuario
  "hems.userGuide.selfUse": "Uso de energía autogenerada",
  "hems.userGuide.selfUseTips": "Primero use la energía solar, si no es suficiente, complete con la red eléctrica",
  "hems.userGuide.economyMode": "Modo económico",
  "hems.userGuide.economyModeTips": "Optimizar la estrategia de uso de energía basada en los precios de la electricidad",
  "hems.userGuide.emergencyMode": "Modo de emergencia",
  "hems.userGuide.emergencyModeTips": "Priorizar el suministro de energía para cargas críticas",

  // Página de gráficos
  "hems.history.energyStatistics": "Estadísticas de energía",
  "hems.history.revenueStatistics": "Estadísticas de ingresos",
  "hems.history.greenStatistics": "Reducción de emisiones verdes",
  "hems.history.revenueTitle": "Ingreso total por venta de electricidad",
  "hems.history.savingsTitle": "Ahorro total",
  "hems.history.carbonTitle": "Reducción total de carbono",
  "hems.history.day": "Día",
  "hems.history.month": "Mes",
  "hems.history.year": "Año",
  "hems.history.beforeDay": "Día anterior",
  "hems.history.afterDay": "Día siguiente",
  "hems.history.beforeMonth": "Mes anterior",
  "hems.history.afterMonth": "Mes siguiente",
  "hems.history.beforeYear": "Año anterior",
  "hems.history.afterYear": "Año siguiente",
  "hems.history.totalUse": "Uso total",
  "hems.history.fullScreen": "Pantalla completa",
  "hems.history.timeSelect": "Seleccione un día",
  "sync.tips1": "¡Comando de sincronización de datos enviado exitosamente!",
  "sync.tips2": "La sincronización de datos está en curso, tarda tiempo debido al gran volumen de datos, verifíquelo nuevamente después de 50 minutos~",
  "sync.tips3": "Si se observa inconsistencia en los datos, la sincronización de datos del dispositivo puede estar retrasada, haga clic en el botón inferior:",
  "sync.tips4": "Sincronizar datos",

  // Información del cargador
  "charge.info": "Información del cargador",
  "news.loading": "Cargando...",
  "news.noMore": "No hay más datos",
  "hems.pv.power": "Cantidad de energía solar",

  // Funcionalidades específicas de UEH
  "ueh.sellPower": "Cantidad de energía para venta",
  
  // Menú
  "menu.home": "Página de inicio",
  "menu.history": "Datos históricos",
  "menu.device": "Dispositivos",
  "menu.settings": "Configuración",
  "menu.messageCenter": "Centro de mensajes",
  "menu.help": "Ayuda y soporte",
  "menu.mine": "Mi cuenta (personal)",


  // Mi configuración
  "mine.userSetting": "Configuración del usuario",
  "mine.terminalSetting": "Configuración de terminal básica",
  "mine.uploadCloud": "Subir datos a la nube",
  "mine.changeVersion": "Verificar actualizaciones",
  "mine.language": "Cambiar idioma",
  "mine.about": "Acerca de la aplicación",
  "mine.feedback": "Retroalimentación",
  "mine.logout": "Cerrar sesión",
  "mine.logoutAccount": "Eliminar cuenta",

  // Relacionado con la eliminación de cuenta
  "mine.logoutAccountTips": "Eliminar cuenta con nombre []",
  "mine.logoutAccountTips1": "Eliminar cuenta vinculada a []",
  "mine.logoutAccountCare": "Consejos para la solicitud de eliminación de cuenta:",
  "mine.logoutAccountCare1": "1. La cuenta está en estado seguro",
  "mine.logoutAccountCare1-1": "La cuenta está en modo de uso normal, no hay riesgo de robo, violación de reglas o cierre",
  "mine.logoutAccountCare2": "2. El acceso y la vinculación de la cuenta serán eliminados",
  "mine.logoutAccountCare2-1": "Todos los permisos de acceso a la cuenta para plataformas de terceros serán eliminados",
  "mine.logoutAccountCare3": "3. Después de la eliminación, la cuenta no se puede recuperar y los datos del usuario serán eliminados",
  "mine.logoutAccountCare3-1": "Después de la eliminación, los números de teléfono, correos electrónicos y datos relacionados vinculados serán eliminados y no se pueden recuperar",
  "mine.confirmLogout": "Confirmar eliminación",
  "mine.logoutSuccess": "¡Cuenta eliminada exitosamente!",


  // Problemas de retroalimentación
  "mine.feedbackIssues": "Problemas y retroalimentación",
  "mine.feedQuantity": "Cantidad",
  "mine.feedAmount": "Máximo 9 fotos, tamaño máximo por foto 1 MB",

  // Relacionado con la configuración de notificaciones
  "mine.notice.fail": "¡Obtención de configuración de notificaciones fallida!",
  "mine.notice.saveSuccess": "¡Guardado de configuración de notificaciones exitoso!",
  "mine.notice.saveFail": "¡Guardado fallido!",
  "mine.notice.title": "Configuración de notificaciones",
  "mine.notice.batteryLow": "Notificación de bajo nivel de batería",
  "mine.notice.chargingFinish": "Notificación de finalización de carga",
  "mine.notice.error": "Notificación de error",
  "mine.notice.update": "Notificación de actualización",
  "mine.notice.monthly": "Notificación de estadísticas mensuales",
  "mine.notice.receiveType": "Método de recepción",

  // Bienvenida a la configuración de idioma
  "mine.language.welcome": "Bienvenido a SusprSafe",
  "mine.language.desc1": "Seleccione la versión del idioma según su dirección doméstica",
  "mine.language.desc2": "Puede cambiarla en cualquier momento en la configuración de la aplicación",

  // Información personal
  "mine.userInfo.avatar": "Foto de perfil",
  "mine.userInfo.nickname": "Apodo",
  "mine.userInfo.password": "Contraseña",
  "mine.userInfo.changePassword": "Modificar contraseña",
  "mine.userInfo.setPassword": "Establecer contraseña",
  "mine.userInfo.phoneNumber": "Número de teléfono",
  "mine.userInfo.bindPhone": "Vincular teléfono",
  "mine.userInfo.bindEmail": "Vincular correo electrónico",
  "mine.loginExpired": "La sesión de inicio de sesión ha expirado, inicie sesión nuevamente",
  "mine.userInfo.title": "Información del usuario",
  "mine.userInfo.bind": "Vincular",
  "mine.userInfo.modify": "Editar",
  "mine.userInfo.modifyNickname": "Modificar apodo",
  "mine.userInfo.userNickname": "Apodo del usuario",
  "mine.userInfo.selectPic": "Seleccione una foto para subir",
  "mine.userInfo.saveSuccess": "Guardado exitoso",
  "mine.userInfo.uploadFail": "Subida fallida",
  "mine.userInfo.avatarSaveSuccess": "Guardado de foto de perfil exitoso",
  "mine.userInfo.nameTips1": "El campo de apodo no puede estar vacío",
  "mine.userInfo.nameTips2": "Ingrese el apodo",

  // Consejos de selección común
  "common.pleaseSelect": "Seleccionar",
  "question.commonQuestions": "Preguntas frecuentes",
  "account.toggleLanguage": "Cambiar idioma",
  "account.localConnection": "Conexión local",
  "account.selectLanguage": "Seleccionar idioma",
  "account.sendEmailToast": "El código de verificación ha sido enviado al correo electrónico xxx, verifíquelo",
  "account.emailError": "Formato de correo electrónico no válido",
  "account.sendEmailFail": "Envío fallido, intente nuevamente",
  
  "common.submitting": "Enviando... espere un momento...",

  "device.page.noData": "No hay datos disponibles en este momento, esta página solo se puede mostrar en la aplicación",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Actualizar",
  "bmsFirmware.upgrading": "Actualizando...",
  "bmsFirmware.uploadingFile": "Subiendo archivo de firmware...",
  "bmsFirmware.upgradingProgress": "Actualizando firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Actualización exitosa",
  "bmsFirmware.upgradeSuccessSubtitle": "¡Actualización del firmware BMS completada!",
  "bmsFirmware.upgradeFailed": "Actualización fallida",
  "bmsFirmware.upgradeFailedFormError": "Por favor, verifique si el formulario está llenado correctamente",
  "bmsFirmware.upgradeFailedNetworkError": "Error de red, por favor inténtelo de nuevo",
  "bmsFirmware.invalidFileType": "Por favor, seleccione un archivo de firmware válido (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Por favor, seleccione primero un archivo de firmware",
  "bmsFirmware.statusUpgrading": "Actualizando",
  "bmsFirmware.statusCompleted": "Actualización completada",
  "bmsFirmware.statusFailed": "Actualización fallida",
  "bmsFirmware.deviceUpgrading": "Actualizando paquete de firmware, la actualización toma de 30 a 50 minutos, no se pueden ver los datos del dispositivo en tiempo real durante este período, por favor espere...",
  "bmsFirmware.upgradeStatusLabel": "Estado de actualización",
  "bmsFirmware.upgradeProgressLabel": "Progreso de actualización",
  "bmsFirmware.currentPackageLabel": "Número del paquete de datos transmitido actualmente",
  "bmsFirmware.totalPackagesLabel": "Número total de paquetes de datos",
  "bmsFirmware.upgradeFailedCheckDevice": "Por favor, verifique el estado del dispositivo y vuelva a intentar la actualización",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Configuración exitosa",
  "settingResult.defaultSubTitle": "Configuración de parámetros guardada",
  "settingResult.confirmButton": "OK"
};